<script>
import axios from "axios";
import Swal from "sweetalert2";
import Layout from '../layouts/main';
import PageHeader from '@/components/page-header';
import {
  authFackMethods
} from "@/state/helpers";

import {
  required
} from "vuelidate/lib/validators";

export default {
  page: {
    title: "Departments",
    meta: [
      {
        name: "Departments",
      },
    ],
  },
  components: { Layout, PageHeader },
  data(){
    return{
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      preservePage: 1,
      pageLimit:50,
      modalTitle:'',
      status: [{ value:'active',text:'Active'},{value:'inactive',text:'InActive'}],
      locations: {},
      departments: {},
      departmentId:'',
      searchBy:'',
      departmentForm: {
        name: "",
        description: "",
        status: null,
        location_id: null,
      },
      searchForm: {
        name: "",
        status: null,
        location: null,
      },
      typesubmit: false,
      isUpdate: false,
      isAdd: false,
      isName: false,
      isLocation: false,
      isStatus: false,
      isSearching: false,
      isLoading:false,
      noRecord: false,
    }
  },
  validations: {
    departmentForm: {
      name: { required },
      description: { required },
      status: { required },
      location_id: { required }
    },
  },
  mounted(){
    this.getDepartments();
  },
  methods: {

    getDepartments(page){
      this.isLoading = true;
      this.noRecord = false;
      if (typeof page === 'undefined'){
        page = 1
      }
      this.preservePage = page;
      let filter = '&per_page='+ this.pageLimit
      if (this.searchForm.name){
        filter += '&name='+ this.searchForm.name
      }
      if (this.searchForm.location){
        filter += '&location='+ this.searchForm.location
      }
      if (this.searchForm.status){
        filter += '&status='+ this.searchForm.status
      }
      axios.get('admin/departments?pagination=true&page='+ page + filter).then(res =>{
        this.departments = res.data.response;
        this.isLoading = false;
        if (!this.departments.data.length){
          this.noRecord = true;
          if (page > 1){
            this.getDepartments(page-1);
          }
        }
      }).catch((err) => {
        if (err.response) {
          if (err.response.status == 401) {
            this.logout();
          }
        }
      })
    },
    ...authFackMethods,

    getLocations(){
      axios.get('admin/locations').then(res =>{
        this.locations = res.data.response;
      })
    },

    showAddModal() {
      this.modalTitle = 'Add Department'
      this.$bvModal.show('departmentModal');
      this.isAdd = true;
      this.isUpdate = false;
      this.getLocations();
      this.departmentForm = {
        name: "",
        description: "",
        status: null,
        location_id: null,
      };
    },

    showEditModal(department) {
      this.getLocations();
      this.modalTitle = 'Edit Department'
      this.$bvModal.show('departmentModal');
      this.departmentForm.name = department.name;
      this.departmentForm.status = department.status;
      this.departmentForm.description = department.description;
      this.departmentForm.location_id = department.location_id;
      this.departmentId = department.id;
      this.isUpdate = true;
      this.isAdd = false;
    },

    deleteDepartment(department) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        showLoaderOnConfirm: true,
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.isConfirmed) {
          var token = localStorage.getItem('token');
          var config = {
            headers: {
              Authorization: 'Bearer ' + token,
              'Accept': 'application/json'
            }
          };
          if (token) {
            axios.delete('admin/departments/'+department.id, config)
                .then((res) => {
                  if (res.status == '200'){
                    Swal.fire({
                      title: "Deleted!",
                      text: department.name + " has been deleted!",
                      icon: "success",
                      width: 350,
                      showConfirmButton: false,
                      timer: 1500
                    });
                    this.getDepartments(this.preservePage);
                  }
                })
                .catch((err) => {
                  if (err.response) {
                    Swal.fire({
                      title: "Error!",
                      text: err.response.data.error.message,
                      icon: "danger",
                      width: 350,
                      showConfirmButton: true
                    });
                  }
                })
          }
        }
      });
    },

    updateDepartmentForm() {
      this.typesubmit = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var token = localStorage.getItem('token');
        var config = {
          headers: {
            Authorization: 'Bearer ' + token,
            'Accept': 'application/json'
          }
        };
        if (token) {
          axios.patch('admin/departments/'+this.departmentId, this.departmentForm, config)
              .then((res) => {
                if (res.status == '200'){
                Swal.fire({
                  title: "Good job!",
                  text:"Department updated successfully!",
                  icon: "success",
                  width: 350,
                  showConfirmButton: false,
                  timer: 1500
                });
                this.getDepartments();
                this.$bvModal.hide('departmentModal');
                this.departmentForm = {
                  name: "",
                  description: "",
                  status: null,
                  location_id: null,
                };
                }
              })
              .catch((err) => {
                if (err.response) {
                  Swal.fire({
                    title: "Error!",
                    text: err.response.data.error.message,
                    icon: "danger",
                    width: 350,
                    showConfirmButton: true
                  });
                }
              })
        }
      }

    },

    addDepartmentForm() {
      this.typesubmit = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var token = localStorage.getItem('token');
        var config = {
          headers: {
            Authorization: 'Bearer ' + token,
            'Accept': 'application/json'
          }
        };
        if (token) {
          axios.post('admin/departments', this.departmentForm, config)
              .then((res) => {
                if (res.status == '200'){
                  Swal.fire({
                    title: "Good job!",
                    text:"Department added successfully!",
                    icon: "success",
                    width: 350,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  this.getDepartments();
                  this.$bvModal.hide('departmentModal');
                  this.departmentForm = {
                    name: "",
                    description: "",
                    status: null,
                    location_id: null,
                  };
                }
              })
              .catch((err) => {
                if (err.response) {
                  Swal.fire({
                    title: "Error!",
                    text: err.response.data.error.message,
                    icon: "danger",
                    width: 350,
                    showConfirmButton: true
                  });
                }
              })
        }
      }

    },

    searchOption(event){
      this.searchForm = {
            name: "",
            status: null,
            location: null,
      };
      let selectedValue = event.target.value
      if (selectedValue == ''){
        this.resetSearch();
      }
      if (selectedValue == 'name') {
        this.getDepartments();
        this.isName = true;
        this.isLocation = false;
        this.isStatus = false;
        this.isSearching = true;
      }
      if (selectedValue == 'location') {
        this.isName = false;
        this.isLocation = true;
        this.isStatus = false;
        this.isSearching = true;
      }
      if (selectedValue == 'status') {
        this.isName = false;
        this.isLocation = false;
        this.isStatus = true;
        this.isSearching = true;
      }
    },

    searchDepartment(){
      this.getDepartments();
    },

    resetSearch(){
      this.searchForm = {
        name: "",
        status: null,
        location: null,
      };
      this.isSearching = false;
      this.isName = false;
      this.isLocation = false;
      this.isStatus = false;
      this.searchBy ='';
      this.getDepartments();
    }

  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="card">
      <div class="card-body">

        <div class="d-flex">
          <div class="me-2">
            <h5 class="card-title mb-3">Departments</h5>
          </div>

          <div class="mb-4 mdl-btns ms-auto">

            <!--Add Department-->
            <b-button id="show-btn" @click="showAddModal" variant="primary" title="Add">
              Add Department
            </b-button>

          </div>

        </div>

        <form class="row align-items-center form-inline mb-4 border p-3 m-0">
          <div class="col-md-12">
            <h4 class="font-size-14">Search By:</h4>
          </div>
          <div class="col-md-4">
            <select
                class="form-select custom-select" v-model="searchBy" @change="searchOption($event)">
              <option value="">Select Option</option>
              <option value="name">Name</option>
              <option value="location">Location</option>
              <option value="status">Status</option>
            </select>
          </div>
          <div class="col-md-2 sm-hidden xs-hidden"></div>
          <div class="col-md-6 pull-right">
            <div class="row app-search pt-0 pb-0">

              <div class="col-md-12 d-flex">
                <input v-if="isName"
                  v-model="searchForm.name"
                  type="text"
                  class="ps-4 form-control"
                  placeholder="Type Department"
              />
                <input v-if="isLocation"
                    v-model="searchForm.location"
                    type="text"
                    class="ps-4 form-control"
                    placeholder="Type Location"
                />
                <b-form-select v-if="isStatus" class="form-select" v-model="searchForm.status" :options="status">
                  <option slot="first" :value="null" disabled>Select Status</option>
                </b-form-select>

                <b-button v-if="isSearching" id="show-btn" class="btn-find" @click="searchDepartment" variant="primary" title="Search">
                  <i class="bx bx-search-alt-2"> Search</i>
                </b-button>

                <b-button v-if="isSearching" class="btn-reset ms-2" id="show-btn" @click="resetSearch"
                          variant="primary" title="Reset">
                  <i class="bx bx-reset"> Reset</i>
                </b-button>
              </div>
          </div>
          </div>
        </form>


        <div class="table-responsive ">
          <table class="table table-bordered table-hover table-striped table-sm align-middle table-nowrap mb-0">

            <thead class="table-light">
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Status</th>
              <th scope="col">Description</th>
              <th scope="col">Location</th>
              <th scope="col">Actions</th>
            </tr>
            </thead>
            <tbody>

            <tr v-if="noRecord">
              <td colspan="5" class="p-0">
                <p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
              </td>
            </tr>
            <tr v-if="isLoading">
              <td colspan="5" class="text-center p-0">
                <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                ></b-spinner>
              </td>
            </tr>

            <tr v-else v-for="(department, index) in departments.data" :key="index">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  {{department.name}}
                </h5>
              </td>
              <td>
                <h5 class="font-size-13 text-truncate text-capitalize mb-1">
                  {{department.status}}
                </h5>
              </td>
              <td>
                <p class="text-muted mb-0 text-wrap ">
                  {{department.description.substr(0, 50) + '...'}}
                </p>
              </td>
              <td>
                <p class="text-muted mb-0 text-wrap">
                  {{department.location ? department.location.name : '-'}}
                </p>
              </td>
              <td class="text-center">
                <b-button id="show-btn" @click="showEditModal(department)" variant="primary" title="Edit">
                  <i class="bx bx-pencil"></i>
                </b-button>
                <b-button @click="deleteDepartment(department)" class="ms-2" variant="danger" title="Delete">
                  <i class="bx bx-trash"></i>
                </b-button>
              </td>

            </tr>

            </tbody>
          </table>
        </div>

        <pagination class="mt-4" :data="departments" :limit="10" @pagination-change-page="getDepartments"></pagination>

      </div>
    </div>

    <b-modal
        id="departmentModal"
        centered
        :title="modalTitle"
        title-class="font-18"
        hide-footer
    >
      <form>

        <div class="mb-3">
          <label>Department Name</label>
          <input
              v-model="departmentForm.name"
              type="text"
              class="form-control"
              placeholder="Enter Department Name"
              name="name"
              :class="{
                    'is-invalid': typesubmit && $v.departmentForm.name.$error,
                  }"
          />
          <div
              v-if="typesubmit && $v.departmentForm.name.$error"
              class="invalid-feedback"
          >
                  <span v-if="!$v.departmentForm.name.required"
                  >Department name is required.</span
                  >
          </div>
        </div>

        <div class="mb-3">
          <label>Description</label>
          <div>
                  <textarea
                      v-model="departmentForm.description"
                      class="form-control"
                      name="description"
                      :class="{
                      'is-invalid': typesubmit && $v.departmentForm.description.$error,
                    }"
                      rows="5" placeholder="Enter Description"
                  ></textarea>
            <div
                v-if="typesubmit && $v.departmentForm.description.$error"
                class="invalid-feedback"
            >
                    <span v-if="!$v.departmentForm.description.required"
                    >Description is required.</span
                    >
            </div>
          </div>
        </div>

        <div class="mb-3">

          <label class="mt-0">Select Status</label>

          <b-form-select class="form-select" v-model="departmentForm.status" :options="status"
                         :class="{'is-invalid': typesubmit && $v.departmentForm.status.$error,}"
          >
            <option slot="first" :value="null" disabled>Select Status</option>
          </b-form-select>
          <div
              v-if="typesubmit && $v.departmentForm.status.$error"
              class="invalid-feedback"
          >
                  <span v-if="!$v.departmentForm.status.required"
                  >Status is required.</span>
          </div>

        </div>

        <div class="mb-3">

          <label class="mt-0">Select Location</label>

          <b-form-select class="form-select" v-model="departmentForm.location_id" :options="locations"
                         value-field="id"
                         text-field="name"
                         :class="{'is-invalid': typesubmit && $v.departmentForm.location_id.$error,}"
          >
            <option slot="first" :value="null" disabled>Select Location</option>
          </b-form-select>
          <div
              v-if="typesubmit && $v.departmentForm.location_id.$error"
              class="invalid-feedback"
          >
                  <span v-if="!$v.departmentForm.location_id.required"
                  >Location is required.</span>
          </div>

        </div>

        <div class="mb-0">
          <div>
            <button type="button" v-if="isAdd" @click="addDepartmentForm" class="btn btn-primary">Add Department</button>
            <button type="button" v-if="isUpdate" @click="updateDepartmentForm" class="btn btn-primary">Update Department</button>
          </div>
        </div>

      </form>
    </b-modal>

  </Layout>
</template>
<style scoped>
.mdl-btns button:nth-child(1){
  margin-right:1rem;
}
.app-search input, .app-search select{
  border-top-right-radius:0px;
  border-bottom-right-radius:0px;
}
.app-search .btn-find{
  width: 40%;
  border-top-right-radius:30px;
  border-bottom-right-radius:30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  box-shadow:none;
}
.app-search .btn-reset{
  width: 40%;
  font-size: 15px;
  box-shadow:none;
  border-radius:30px;
}
</style>
